import { CepUtils } from 'px-components';

export default function (value) {
  if (!value) {
    return '';
  }

  let pais = '';
  if (value.pais) {
    pais = `, ${value.pais}`;
  }

  const cep = value.cep ? CepUtils(value.cep) : value.codigoPostal;

  const cidade = value.municipio;
  const estado = value.uf;

  return `${value.logradouro}, ${value.numero || 'SN'}, ${value.bairro ? (`${value.bairro} - `) : ''}
        ${cidade}, ${estado} -
        ${cep}${pais}`;
}
